module.exports = __webpack_public_path__ + "f263befbdbe7f8d655cf7ee92fa8509e.png";